const l = (o) => ({
  chip: {
    fontFamily: "inherit",
    borderRadius: 100,
    height: 22,
    color: o.palette.common.white,
    "&.MuiChip-filledDefault": {
      backgroundColor: o.palette.common.blue400
    },
    // Label
    "& > .MuiChip-label": {
      ...o.typography.smallText
    },
    "&.MuiChip-orange": {
      backgroundColor: o.palette.common.orange200,
      borderRadius: 4,
      "& > .MuiChip-label": {
        padding: "0px 6px",
        color: o.palette.common.blue400
      }
    },
    "&.MuiChip-green": {
      backgroundColor: o.palette.common.green100,
      borderRadius: 4,
      "& > .MuiChip-label": {
        padding: "0px 6px",
        color: o.palette.common.blue400
      }
    },
    "&.MuiChip-gray": {
      backgroundColor: o.palette.common.grey30,
      borderRadius: 4,
      "& > .MuiChip-label": {
        padding: "0px 6px",
        color: o.palette.common.blue400
      }
    }
  }
}), a = l;
export {
  a as default
};
